/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateUserOptions,
  UpdateUserStatus201,
  UpdateUserStatus400,
  UpdateUserStatus404,
  UpdateUserStatus500,
} from '../types/UpdateUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateUser } from '../clients/updateUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateUserMutationKey = () => [{ url: '/v1/user/:user_id' }] as const

export function updateUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateUserMutationKey()
  return mutationOptions<
    UpdateUserStatus201,
    ResponseErrorConfig<UpdateUserStatus400 | UpdateUserStatus404 | UpdateUserStatus500>,
    UpdateUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateUser({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update user by ID (admin only)
 * {@link /v1/user/:user_id}
 */
export function useUpdateUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateUserStatus201,
      ResponseErrorConfig<UpdateUserStatus400 | UpdateUserStatus404 | UpdateUserStatus500>,
      UpdateUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateUserMutationKey()

  const baseOptions = updateUserMutationOptions(config) as UseMutationOptions<
    UpdateUserStatus201,
    ResponseErrorConfig<UpdateUserStatus400 | UpdateUserStatus404 | UpdateUserStatus500>,
    UpdateUserOptions,
    TContext
  >

  return useMutation<
    UpdateUserStatus201,
    ResponseErrorConfig<UpdateUserStatus400 | UpdateUserStatus404 | UpdateUserStatus500>,
    UpdateUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateUserStatus201,
    ResponseErrorConfig<UpdateUserStatus400 | UpdateUserStatus404 | UpdateUserStatus500>,
    UpdateUserOptions,
    TContext
  >
}
